import { gql } from 'apollo-boost';

export const USER_FRAGMENT = gql`
  fragment User on UserType {
    id
    auth0Id
    fullName
    givenName
    familyName
    preferredName
    displayName
    email
    agencyName
    agencyId
    customURL
    role
    auth0Roles{
      id
      name
      description
    }
    auth0Permissions{
      name
      description
    }
    status
    isBroker
    hasIBMAccess
    phone {
      extension
      number
    }
    __typename
  }
`;

export const AUTH0USER_FRAGMENT = gql`
  fragment Auth0User on Auth0UserType {
    id
    email
    fullName
    displayName
    phone {
      extension
      number
    }
    givenName
    familyName
    agencyName
    preferredName
    isBroker
    status
    role
    __typename
  }
`;
